import { useCallback, useState } from "react";

import { CheckInManagerTourDialog, CheckInManagerTourDialogProps } from "./CheckInManagerTourDialog";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { trpc } from "@/common/helpers/trpc";

type ConnectedCheckInManagerTourDialogProps = {
  open: boolean;
  onClose: () => void;
  onTourComplete?: () => void;
};

export const ConnectedCheckInManagerTourDialog = ({
  open,
  onClose,
  onTourComplete,
}: ConnectedCheckInManagerTourDialogProps) => {
  const [step, setStep] = useState<CheckInManagerTourDialogProps["step"]>(1);

  const { currentUser } = useCurrentUserContext();
  const { mutateAsync: setUserAsOnboardedOnCheckinManager } = trpc.setUserAsOnboardedOnCheckinManager.useMutation();

  const handleOnComplete = useCallback(async () => {
    if (currentUser) {
      await setUserAsOnboardedOnCheckinManager();
    }
    onClose();
    onTourComplete?.();
  }, [currentUser, onClose, setUserAsOnboardedOnCheckinManager, onTourComplete]);

  return (
    <CheckInManagerTourDialog
      open={open}
      onClose={onClose}
      step={step}
      onGoToStep={setStep}
      onComplete={handleOnComplete}
    />
  );
};
